// import axios from 'axios';
// import React, { useEffect, useState, useRef } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { useLocation } from 'react-router-dom';
// import apiUrl from '../../Environment/Api';
// import { ToWords } from 'to-words';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import html2canvas from 'html2canvas';


// function InvoicePrint() {
//     const navigate = useNavigate();
//     const printRef = useRef(false);
//     const [pdfGenerated, setPdfGenerated] = useState(false);
//     const { invoice_id } = useParams();
//     const location = useLocation();

//     useEffect(() => {
//         const delay = 1000;
//         let cleanupFunction;

//         console.log('Working for Print');
//         const printTimer = setTimeout(() => {
//             if (!printRef.current) {
//                 window.onbeforeprint = function() {
//                     document.title = `${invoice_id}`;
//                 };
//                 window.print();
//                 printRef.current = true;
//             }
//             else {
//                 navigate('/invoice');
//             }
//         }, delay);


//         return () => {
//             if (cleanupFunction) {
//                 cleanupFunction();
//             }
//         };
//     }, [invoice_id, navigate, pdfGenerated]);



//     const [invoiceData, setInvoiceDetails] = useState({});
//     const [invoiceList, setInvoiceList] = useState([]);
//     const [gettaxpercentage, settaxpercentage] = useState([]);

//     const getdata = async () => {
//         const id = invoice_id;

//         try {
//             const responseDetails = await axios.get(apiUrl + `/invoicedetails/${id}`);
//             console.log("invoice details data", responseDetails.data);
//             setInvoiceDetails(responseDetails.data);
//         } catch (err) {
//             console.log(err);
//         }

//         try {
//             const responseList = await axios.get(apiUrl + `/invoicelist/${id}`);
//             console.log("invoice list data", responseList.data);
//             setInvoiceList(responseList.data);
//             console.log("the tax percentage", responseList.data[0].tax)
//             settaxpercentage(responseList.data[0].tax);

//         } catch (err) {
//             console.log(err);
//         }
//     }

//     useEffect(() => {
//         getdata();
//         clientdetails();
//     }, [invoice_id]);

//     // to get client details ---------------
//     const [ClientDetails, setClientDetails] = useState([]);
//     const clientdetails = async () => {
//         try {
//             const response = await axios.get(apiUrl + "/clientdetails");
//             if (response) {
//                 setClientDetails(response.data);
//             }
//         } catch (error) {
//             console.error("Error fetching client details:", error);
//         }
//     };

//     const [getclientaddress, setclientaddress] = useState('')
//     const [getclientcountry, setclientcountry] = useState('')
//     const [getclientName, setclientName] = useState('');
//     const [getclientmobile, setclientmobile] = useState('');
//     const [getmobilecode, setmobilecode] = useState('');

//     useEffect(() => {
//         if (ClientDetails.length > 0 && invoiceData[0]?.clientId) {
//             const clientaddresscountryfilter = ClientDetails.filter((data) => data.id === invoiceData[0]?.clientId);
//             console.log("filter data", clientaddresscountryfilter);

//             if (clientaddresscountryfilter.length > 0) {
//                 setclientName(clientaddresscountryfilter[0].clientName);
//                 setclientaddress(clientaddresscountryfilter[0].address);
//                 setclientcountry(clientaddresscountryfilter[0].country);
//                 setclientmobile(clientaddresscountryfilter[0].mobile);
//                 setmobilecode(clientaddresscountryfilter[0].countrycode);
//             }
//         }
//     }, [ClientDetails, invoiceData]);



//     const fulltableData = [...(invoiceList || [])];

//     // Calculate subtotal, tax, and net total
//     const subtotal = fulltableData.reduce((acc, row) => acc + parseFloat(row.price), 0);
//     const tax = fulltableData.reduce((acc, row) => acc + parseFloat(row.tax), 0);
//     const netTotal = fulltableData.reduce((acc, row) => acc + parseFloat(row.totalAmount), 0);
//     // Calculate total quantity, total price, total tax, and total amount
//     let totalQuantity = 0;
//     let totalPrice = 0;
//     let totalTax = 0;
//     let totalAmount = 0;
//     let sub = 0;

//     fulltableData.forEach(row => {
//         totalQuantity += parseInt(row.quantity);
//         totalPrice += parseFloat(row.price);
//         totalTax += parseFloat(row.tax);
//         totalAmount += (parseFloat(row.quantity) * parseFloat(row.price)) + parseFloat(row.tax * row.quantity * row.price / 100);
//         sub += (parseFloat(row.quantity) * parseFloat(row.price))
//     });


//     const toWords = new ToWords({
//         localeCode: 'en-IN',
//         converterOptions: {
//             currency: true,
//             ignoreDecimal: false,
//             ignoreZeroCurrency: false,
//             doNotAddOnly: false,
//             currencyOptions: {
//                 name: getmobilecode === '91' ? 'Rupees' : 'Dollar',
//                 plural: getmobilecode === '91' ? 'Rupees' : 'Dollar',
//                 symbol: getmobilecode === '91' ? '₹' : '$',
//                 fractionalUnit: {
//                     name: getmobilecode === '91' ? 'Paisa' : 'Cents',
//                     plural: getmobilecode === '91' ? 'Paisa' : 'Cents',
//                     symbol: '',
//                 },
//             }
//         }
//     });

//     console.log("invoiceData", invoiceData);
//     console.log("totalTax", invoiceData[0]?.totalTax);

//     let words = toWords.convert(totalAmount);

//     const formatDate = (dateString) => {
//         const options = { month: 'short', year: 'numeric' };
//         const formattedDate = new Date(dateString).toLocaleDateString('en-US', options);
//         return formattedDate;
//     };
//     const formatDate1 = (dateString) => {
//         if (!dateString || dateString === "Invalid Date") {
//             return ""; // Return empty string for invalid or empty dates
//         }

//         const date = new Date(dateString);
//         const formattedDate = date.toLocaleDateString('en-GB', {
//             day: '2-digit',
//             month: '2-digit',
//             year: 'numeric',
//         }).replace(/\//g, '-'); // Replace slashes with hyphens

//         return formattedDate;
//     };




//     return (

//         <div id="invoice-content" className='background-color-bill' style={{
//             width: "100%",
//             margin: "0px",
//             fontSize:"15px",
//             backgroundColor: 'white'
//         }}>
//             <h3 className='text-center mb-1'>Invoice Bill</h3>
//             <div>
//                 <div className='row mb-1'>
//                     <div className='col-lg-6 col-md-6 col-sm-6 '>
//                         <div className='row'>
//                             <img className='logo-bill' src={window.location.origin + require('../../../assets/img/Admin/Logo.png')} />

//                         </div>

//                     </div>

//                     <div className='col-lg-6 col-md-6 col-sm-6 mt-4'>
//                         <div className='row'>
//                             <div className='col-lg-8 col-md-8 col-sm-8 line-height-space3'>
//                                 <p className='invoice-list  text-end'><b>Invoice No</b></p>
//                                 <p className='invoice-list  text-end'><b>Invoice Date</b></p>
//                                 <p className='invoice-list  text-end'><b>Due Date</b></p>
//                                 <p className='invoice-list  text-end'><b>Balance Due</b></p>
//                             </div>
//                             <div className='col-lg-4 col-md-4 col-sm-4 line-height-space3'>
//                                 <p className='text-black'>:  {invoiceData[0]?.invoiceId}</p>
//                                 <p className='text-black'>:  {formatDate1(invoiceData[0]?.date)}</p>
//                                 <p className='text-black'>:  {formatDate1(invoiceData[0]?.dueDate)} </p>
//                                 <p className='text-black'>:  <b>${totalAmount.toFixed(2)}</b> </p>
//                             </div>
//                         </div>

//                     </div>
//                     <hr />
//                 </div>
//                 <div className='row'>
//                     <div className='col-lg-4 col-md-4 col-sm-4'>
//                         <div className=' row logo-row line line-height-space3 mt-1'>
//                             <b className='text-black'><p>VAS Post Production</p></b>
//                             <p className='text-black'><b><i class="fa-solid fa-user"></i> - Vasanthan. K</b></p>
//                             <p className='text-black'><b><i class="fa-solid fa-phone"></i></b> - +91 7708024254</p>
//                             <p className='text-black'><i class="fa-solid fa-house"></i> - 87, Kamarajar Nagar,</p>
//                             <p className='text-black indent'>Dadagapatti,</p>
//                             <p className='text-black indent'>Salam-6.</p>

//                         </div>
//                     </div>
//                     <div className='col-lg-4 col-md-4 col-sm-4 '></div>
//                     <div className='col-lg-4 col-md-4 col-sm-4 '>
//                         <div className='row'>
//                             <p className='text-black'><b>Bill to : </b></p>
//                         </div>
//                         <div className=' logo-row line line-height-space3'>
//                             <p className='text-black'><b><i class="fa-solid fa-user"></i> - {getclientName}</b>,</p>
//                             <p className='text-black'><i class="fa-solid fa-phone"></i> - +{getmobilecode} {getclientmobile},</p>
//                             <h6 className='text-black'><i class="fa-solid fa-house"></i> - {getclientaddress},</h6>
//                             <p className='text-black indent'>{getclientcountry},</p>


//                         </div>
//                     </div>
//                 </div>
//                 <div className='row m-1'>
//                     <table className='table table-striped'>
//                         <thead className='table-dark'>
//                             <tr>
//                                 <th className='sno' scope="col">S No.</th>
//                                 <th className='datetable' scope="col">Date</th>
//                                 <th scope="col">Project</th>
//                                 <th scope="col">Type</th>
//                                 <th scope="col">Qty</th>
//                                 <th className='pricetableprint' scope="col">Price</th>
//                                 <th className='amounttableprint' scope="col">Amount</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {fulltableData.map((row, index) => (
//                                 <tr key={index} className={index % 2 === 1 ? 'table-secondary' : ''}>
//                                     <td className='text-center sno' scope="row">{index + 1}</td>
//                                     <td className='datetable'>{formatDate1(row.date)}</td>
//                                     <td>{row.projectName}</td>
//                                     <td>{row.type}</td>
//                                     <td>{row.quantity}</td>
//                                     <td className='pricetableprint'>
//                                         {(() => {
//                                             const clientData = ClientDetails.find(client => client.id === row.clientId);

//                                             if (clientData) {
//                                                 const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
//                                                 return (
//                                                     <span>
//                                                         {currencySymbol} {parseFloat(row.price).toFixed(2)}
//                                                     </span>
//                                                 );
//                                             }
//                                             return null;
//                                         })()}
//                                     </td>
//                                     {/* <td>${parseFloat(row.price).toFixed(2)}</td> */}
//                                     <td className='amounttableprint'>
//                                         {(() => {
//                                             const clientData = ClientDetails.find(client => client.id === row.clientId);

//                                             if (clientData) {
//                                                 const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
//                                                 return (
//                                                     <span>
//                                                         {currencySymbol} {((parseFloat(row.quantity) * parseFloat(row.price)).toFixed(2))}
//                                                     </span>
//                                                 );
//                                             }
//                                             return null;
//                                         })()}
//                                     </td>
//                                     {/* <td>${((parseFloat(row.quantity) * parseFloat(row.price)).toFixed(2))}</td> */}
//                                 </tr>
//                             ))}
//                             <tr>
//                                 <td></td>
//                                 <td></td>
//                                 <td></td>
//                                 <td><b>Total</b></td>
//                                 {/* <td>
//                                     {(() => {
//                                         // Use the first row to get the clientId
//                                         const clientData = ClientDetails.find(client => client.id === fulltableData[0]?.clientId);

//                                         if (clientData) {
//                                             const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
//                                             return (
//                                                 <span>
//                                                     {currencySymbol} {totalQuantity}
//                                                 </span>
//                                             );
//                                         }
//                                         return null;
//                                     })()}
//                                 </td> */}
//                                 <td>{totalQuantity}</td>
//                                 <td></td>
//                                 <td>
//                                     {(() => {
//                                         // Use the first row to get the clientId
//                                         const clientData = ClientDetails.find(client => client.id === fulltableData[0]?.clientId);

//                                         if (clientData) {
//                                             const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
//                                             return (
//                                                 <span>
//                                                     {currencySymbol} {sub.toFixed(2)}
//                                                 </span>
//                                             );
//                                         }
//                                         return null;
//                                     })()}
//                                 </td>
//                                 {/* <td>${sub.toFixed(2)}</td> */}
//                             </tr>
//                         </tbody>
//                     </table>


//                 </div>

//                 <br />
//                 <div className='row'>
//                     <div className='col-lg-4 col-md-4 col-sm-4 '>

//                         <p className='form-label notes-style'><b>Amount in Words : </b> </p>
//                         <p className='notes-style text-black'>{words}</p>
//                         <p className='form-label notes-style'><b>Notes</b> </p>
//                         <p className='notes-style'>{invoiceData[0]?.notes}</p>
//                     </div>

//                     <div className='col-lg-8 col-md-8 col-sm-8 '>
//                         <div className='row total-content'>
//                             <div className='col-lg-7 col-md-7 col-sm-7 line-height-space3'>
//                                 <p className='invoice-list text-end'><b>Sub Total</b> </p>
//                                 <p className='invoice-list text-end'><b>Paypal Tax ({gettaxpercentage}%)</b></p>
//                                 <p className='invoice-list text-end'><b>Net Total</b></p>
//                             </div>
//                             <div className='col-lg-5 col-md-5 col-sm-5 line-height-space3'>
//                                 {/* <p className='text-black'>: ${sub.toFixed(2)}</p> */}
//                                 <p className='text-black'>:

//                                     {(() => {
//                                         // Use the first row to get the clientId
//                                         const clientData = ClientDetails.find(client => client.id === fulltableData[0]?.clientId);

//                                         if (clientData) {
//                                             const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
//                                             return (
//                                                 <span>
//                                                     {currencySymbol} {sub.toFixed(2)}
//                                                 </span>
//                                             );
//                                         }
//                                         return null;
//                                     })()}

//                                 </p>
//                                 <p className='text-black'>:
//                                     {(() => {
//                                         // Use the first row to get the clientId
//                                         const clientData = ClientDetails.find(client => client.id === fulltableData[0]?.clientId);

//                                         if (clientData) {
//                                             const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
//                                             return (
//                                                 <span>
//                                                     {currencySymbol} {parseFloat(invoiceData[0]?.totalTax).toFixed(2)}
//                                                 </span>
//                                             );
//                                         }
//                                         return null;
//                                     })()}


//                                 </p>
//                                 <b className='text-black'>:

//                                     {(() => {
//                                         // Use the first row to get the clientId
//                                         const clientData = ClientDetails.find(client => client.id === fulltableData[0]?.clientId);

//                                         if (clientData) {
//                                             const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
//                                             return (
//                                                 <span>
//                                                     {currencySymbol} {totalAmount.toFixed(2)}
//                                                 </span>
//                                             );
//                                         }
//                                         return null;
//                                     })()}

//                                 </b>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>

//     )
// }

// export default InvoicePrint;


// import axios from 'axios';
// import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import apiUrl from '../../Environment/Api';
// import { ToWords } from 'to-words';

// // Constants
// const COUNTRY_CODE_INDIA = '91';
// const PRINT_DELAY = 1000;

// const CURRENCY_CONFIG = {
//     [COUNTRY_CODE_INDIA]: {
//         symbol: '₹',
//         name: 'Rupees',
//         fractionalUnit: 'Paisa'
//     },
//     default: {
//         symbol: '$',
//         name: 'Dollar',
//         fractionalUnit: 'Cents'
//     }
// };

// // Helper Functions
// const getCurrencyConfig = (countryCode) => {
//     return countryCode === COUNTRY_CODE_INDIA
//         ? CURRENCY_CONFIG[COUNTRY_CODE_INDIA]
//         : CURRENCY_CONFIG.default;
// };

// const formatDate = (dateString, format = 'short') => {
//     if (!dateString || dateString === "Invalid Date") {
//         return "";
//     }

//     const date = new Date(dateString);

//     if (format === 'short') {
//         return date.toLocaleDateString('en-US', {
//             month: 'short',
//             year: 'numeric'
//         });
//     }

//     return date.toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: '2-digit',
//         year: 'numeric',
//     }).replace(/\//g, '-');
// };

// // Sub-components
// const InvoiceHeader = ({ invoiceData, totalAmount }) => (
//     <div className='row mb-1'>
//         <div className='col-lg-6 col-md-6 col-sm-6'>
//             <img
//                 className='logo-bill'
//                 src={window.location.origin + require('../../../assets/img/Admin/Logo.png')}
//                 alt="Company Logo"
//             />
//         </div>
//         <div className='col-lg-6 col-md-6 col-sm-6 mt-4'>
//             <div className='row'>
//                 <div className='col-lg-8 col-md-8 col-sm-8 line-height-space3'>
//                     <p className='invoice-list text-end'><b>Invoice No : {invoiceData?.invoiceId} </b></p>
//                     <p className='invoice-list text-end'><b>Invoice Date : {formatDate(invoiceData?.date, 'full')}</b></p>
//                     <p className='invoice-list text-end'><b>Due Date : {formatDate(invoiceData?.dueDate, 'full')}</b></p>
//                     <p className='invoice-list text-end'><b>Balance Due : ${totalAmount.toFixed(2)}</b></p>
//                 </div>
//                 {/* <div className='col-lg-4 col-md-4 col-sm-4 line-height-space3'>
//           <p className='text-black'></p>
//           <p className='text-black'></p>
//           <p className='text-black'></p>
//           <p className='text-black'></b></p>
//         </div> */}
//             </div>
//         </div>
//         <hr />
//     </div>
// );

// const CompanyInfo = () => (
//     <div className='logo-row line line-height-space3 mt-1'>
//         <b className='text-black'><p>VAS Post Production</p></b>
//         <p className='text-black'><b><i className="fa-solid fa-user"></i> - Vasanthan. K</b></p>
//         <p className='text-black'><b><i className="fa-solid fa-phone"></i></b> - +91 7708024254</p>
//         <p className='text-black'><i className="fa-solid fa-house"></i> - 87, Kamarajar Nagar,</p>
//         <p className='text-black indent'>Dadagapatti,</p>
//         <p className='text-black indent'>Salam-6.</p>
//     </div>
// );

// const ClientInfo = ({ clientDetails }) => (
//     <div>
//         <div className='row'>
//             <p className='text-black'><b>Bill to : </b></p>
//         </div>
//         <div className='logo-row line line-height-space3'>
//             <p className='text-black'>
//                 <b><i className="fa-solid fa-user"></i> - {clientDetails.name}</b>,
//             </p>
//             <p className='text-black'>
//                 <i className="fa-solid fa-phone"></i> - +{clientDetails.countryCode} {clientDetails.mobile},
//             </p>
//             <h6 className='text-black'>
//                 <i className="fa-solid fa-house"></i> - {clientDetails.address},
//             </h6>
//             <p className='text-black indent'>{clientDetails.country},</p>
//         </div>
//     </div>
// );

// const InvoiceTable = ({ items, clientDetails, currencySymbol }) => {
//     // Calculate totals for all billing columns
//     const totals = useMemo(() => {
//         return items.reduce((acc, row) => {
//             const standard = parseFloat(row.standard || 0);
//             const premier = parseFloat(row.premier || 0);
//             const twilight = parseFloat(row.twilight || 0);
//             const day_to_dusk = parseFloat(row.day_to_dusk || 0);
//             const vra = parseFloat(row.vra || 0);
//             const vr = parseFloat(row.vr || 0);
//             const col7 = parseFloat(row.col7 || 0);
//             const col8 = parseFloat(row.col8 || 0);
//             const col9 = parseFloat(row.col9 || 0);
//             const col10 = parseFloat(row.col10 || 0);
//             const col11 = parseFloat(row.col11 || 0);
//             const col12 = parseFloat(row.col12 || 0);
//             const price = parseFloat(row.price || 0);

//             // Sum all column values + price for this row
//             const rowTotal = standard + premier + twilight + day_to_dusk + vra + vr +
//                 col7 + col8 + col9 + col10 + col11 + col12 + price;

//             return {
//                 standard: acc.standard + standard,
//                 premier: acc.premier + premier,
//                 twilight: acc.twilight + twilight,
//                 day_to_dusk: acc.day_to_dusk + day_to_dusk,
//                 vra: acc.vra + vra,
//                 vr: acc.vr + vr,
//                 col7: acc.col7 + col7,
//                 col8: acc.col8 + col8,
//                 col9: acc.col9 + col9,
//                 col10: acc.col10 + col10,
//                 col11: acc.col11 + col11,
//                 col12: acc.col12 + col12,
//                 price: acc.price + price,
//                 subtotal: acc.subtotal + rowTotal
//             };
//         }, {
//             standard: 0, premier: 0, twilight: 0, day_to_dusk: 0, vra: 0, vr: 0,
//             col7: 0, col8: 0, col9: 0, col10: 0, col11: 0, col12: 0,
//             price: 0, subtotal: 0
//         });
//     }, [items]);

//     // Check which dynamic columns have data
//     const dynamicColumns = ['col7', 'col8', 'col9', 'col10', 'col11', 'col12'];
//     const columnsWithData = dynamicColumns.filter(col =>
//         items.some(item => item[col] && item[col].toString().trim() !== '' && parseFloat(item[col] || 0) !== 0)
//     );

//     return (
//         <table className='table table-striped'>
//             <thead className='table-dark'>
//                 <tr>
//                     <th className='sno' scope="col">S No.</th>
//                     <th className='datetable' scope="col">Date</th>
//                     <th scope="col">Address</th>
//                     <th scope="col">Standard</th>
//                     <th scope="col">Premier</th>
//                     <th scope="col">Twilight</th>
//                     <th scope="col">Day to Dusk</th>
//                     <th scope="col">VRA(5$)</th>
//                     <th scope="col">VR(12$)</th>

//                     {/* Dynamic columns - only show if they have data */}
//                     {columnsWithData.map(col => (
//                         <th key={col} scope="col">{col.toUpperCase()}</th>
//                     ))}

//                     <th className='pricetableprint' scope="col">Price</th>
//                     <th className='amounttableprint' scope="col">Amount</th>
//                 </tr>
//             </thead>
//             <tbody>
//                 {items.map((row, index) => {
//                     // Add all column values + price for this row
//                     const rowAmount = (parseFloat(row.standard || 0) +
//                         parseFloat(row.premier || 0) +
//                         parseFloat(row.twilight || 0) +
//                         parseFloat(row.day_to_dusk || 0) +
//                         parseFloat(row.vra || 0) +
//                         parseFloat(row.vr || 0) +
//                         parseFloat(row.col7 || 0) +
//                         parseFloat(row.col8 || 0) +
//                         parseFloat(row.col9 || 0) +
//                         parseFloat(row.col10 || 0) +
//                         parseFloat(row.col11 || 0) +
//                         parseFloat(row.col12 || 0) +
//                         parseFloat(row.price || 0));

//                     return (
//                         <tr key={index} className={index % 2 === 1 ? 'table-secondary' : ''}>
//                             <td className='text-center sno' scope="row">{index + 1}</td>
//                             <td className='datetable'>{formatDate(row.date, 'full')}</td>
//                             <td>{row.projectName}</td>
//                             <td className='text-center'>{row.standard || '-'}</td>
//                             <td className='text-center'>{row.premier || '-'}</td>
//                             <td className='text-center'>{row.twilight || '-'}</td>
//                             <td className='text-center'>{row.day_to_dusk || '-'}</td>
//                             <td className='text-center'>{row.vra || '-'}</td>
//                             <td className='text-center'>{row.vr || '-'}</td>

//                             {/* Dynamic column values */}
//                             {columnsWithData.map(col => (
//                                 <td key={col} className='text-center'>{row[col] || '-'}</td>
//                             ))}

//                             <td className='pricetableprint'>
//                                 {currencySymbol} {parseFloat(row.price || 0).toFixed(2)}
//                             </td>
//                             <td className='amounttableprint'>
//                                 {currencySymbol} {rowAmount.toFixed(2)}
//                             </td>
//                         </tr>
//                     );
//                 })}
//                 <tr className='table-light'>
//                     <td></td>
//                     <td></td>
//                     <td><b>Total</b></td>
//                     <td className='text-center'><b>{totals.standard.toFixed(2)}</b></td>
//                     <td className='text-center'><b>{totals.premier.toFixed(2)}</b></td>
//                     <td className='text-center'><b>{totals.twilight.toFixed(2)}</b></td>
//                     <td className='text-center'><b>{totals.day_to_dusk.toFixed(2)}</b></td>
//                     <td className='text-center'><b>{totals.vra.toFixed(2)}</b></td>
//                     <td className='text-center'><b>{totals.vr.toFixed(2)}</b></td>
//                     {columnsWithData.map(col => (
//                         <td key={`total-${col}`} className='text-center'><b>{totals[col].toFixed(2)}</b></td>
//                     ))}
//                     <td className='text-center'><b>{currencySymbol} {totals.price.toFixed(2)}</b></td>
//                     <td><b>{currencySymbol} {totals.subtotal.toFixed(2)}</b></td>
//                 </tr>
//             </tbody>
//         </table>
//     );
// };

// const InvoiceSummary = ({
//     subtotal,
//     taxPercentage,
//     totalTax,
//     total,
//     currencySymbol,
//     notes,
//     amountInWords
// }) => (
//     <div className='row'>
//         <div className='col-lg-4 col-md-4 col-sm-4'>
//             <p className='form-label notes-style'><b>Amount in Words : </b></p>
//             <p className='notes-style text-black'>{amountInWords}</p>
//             <p className='form-label notes-style'><b>Notes</b></p>
//             <p className='notes-style'>{notes}</p>
//         </div>
//         <div className='col-lg-8 col-md-8 col-sm-8'>
//             <div className='row total-content'>
//                 <div className='col-lg-7 col-md-7 col-sm-7 line-height-space3'>
//                     <p className='invoice-list text-end'><b>Sub Total</b></p>
//                     <p className='invoice-list text-end'><b>Paypal Tax ({taxPercentage}%)</b></p>
//                     <p className='invoice-list text-end'><b>Net Total</b></p>
//                 </div>
//                 <div className='col-lg-5 col-md-5 col-sm-5 line-height-space3'>
//                     <p className='text-black'>: {currencySymbol} {subtotal.toFixed(2)}</p>
//                     <p className='text-black'>: {currencySymbol} {totalTax.toFixed(2)}</p>
//                     <b className='text-black'>: {currencySymbol} {total.toFixed(2)}</b>
//                 </div>
//             </div>
//         </div>
//     </div>
// );

// // Main Component
// function InvoicePrint() {
//     const navigate = useNavigate();
//     const printRef = useRef(false);
//     const { invoice_id } = useParams();

//     // State
//     const [invoiceData, setInvoiceData] = useState(null);
//     const [invoiceList, setInvoiceList] = useState([]);
//     const [clientDetails, setClientDetails] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     // Fetch invoice data
//     const fetchInvoiceData = useCallback(async () => {
//         try {
//             setLoading(true);
//             setError(null);

//             const [detailsResponse, listResponse, clientsResponse] = await Promise.all([
//                 axios.get(`${apiUrl}/invoicedetails/${invoice_id}`),
//                 axios.get(`${apiUrl}/invoicelist/${invoice_id}`),
//                 axios.get(`${apiUrl}/clientdetails`)
//             ]);

//             setInvoiceData(detailsResponse.data[0]);
//             setInvoiceList(listResponse.data);
//             console.log("===== INVOICE LIST DATA FROM BACKEND =====");
//             console.log(JSON.stringify(listResponse.data, null, 2)); // ADD THIS
//             console.log("==========================================");
//             setClientDetails(clientsResponse.data);
//         } catch (err) {
//             console.error('Error fetching invoice data:', err);
//             setError('Failed to load invoice data');
//         } finally {
//             setLoading(false);
//         }
//     }, [invoice_id]);

//     useEffect(() => {
//         fetchInvoiceData();
//     }, [fetchInvoiceData]);

//     // Handle printing
//     useEffect(() => {
//         if (loading || !invoiceData) return;

//         const printTimer = setTimeout(() => {
//             if (!printRef.current) {
//                 window.onbeforeprint = () => {
//                     document.title = `${invoice_id}`;
//                 };
//                 window.print();
//                 printRef.current = true;
//             } else {
//                 navigate('/invoice');
//             }
//         }, PRINT_DELAY);

//         return () => clearTimeout(printTimer);
//     }, [invoice_id, navigate, loading, invoiceData]);

//     // Derived data
//     const currentClient = useMemo(() => {
//         if (!invoiceData?.clientId || !clientDetails.length) return null;

//         const client = clientDetails.find(c => c.id === invoiceData.clientId);
//         return client ? {
//             name: client.clientName,
//             address: client.address,
//             country: client.country,
//             mobile: client.mobile,
//             countryCode: client.countrycode
//         } : null;
//     }, [clientDetails, invoiceData]);

//     const currencyConfig = useMemo(() => {
//         return getCurrencyConfig(currentClient?.countryCode);
//     }, [currentClient]);

//     const calculations = useMemo(() => {
//         const subtotal = invoiceList.reduce((acc, row) => {
//             const standard = parseFloat(row.standard || 0);
//             const premier = parseFloat(row.premier || 0);
//             const twilight = parseFloat(row.twilight || 0);
//             const day_to_dusk = parseFloat(row.day_to_dusk || 0);
//             const vra = parseFloat(row.vra || 0);
//             const vr = parseFloat(row.vr || 0);
//             const col7 = parseFloat(row.col7 || 0);
//             const col8 = parseFloat(row.col8 || 0);
//             const col9 = parseFloat(row.col9 || 0);
//             const col10 = parseFloat(row.col10 || 0);
//             const col11 = parseFloat(row.col11 || 0);
//             const col12 = parseFloat(row.col12 || 0);
//             const price = parseFloat(row.price || 0);

//             const rowTotal = standard + premier + twilight + day_to_dusk + vra + vr +
//                 col7 + col8 + col9 + col10 + col11 + col12 + price;

//             return acc + rowTotal;
//         }, 0);

//         const totalTax = parseFloat(invoiceData?.totalTax || 0);
//         const total = subtotal + totalTax;
//         const taxPercentage = invoiceList[0]?.tax || 0;

//         return { subtotal, totalTax, total, taxPercentage };
//     }, [invoiceList, invoiceData]);

//     const amountInWords = useMemo(() => {
//         const toWords = new ToWords({
//             localeCode: 'en-IN',
//             converterOptions: {
//                 currency: true,
//                 ignoreDecimal: false,
//                 ignoreZeroCurrency: false,
//                 doNotAddOnly: false,
//                 currencyOptions: {
//                     name: currencyConfig.name,
//                     plural: currencyConfig.name,
//                     symbol: currencyConfig.symbol,
//                     fractionalUnit: {
//                         name: currencyConfig.fractionalUnit,
//                         plural: currencyConfig.fractionalUnit,
//                         symbol: '',
//                     },
//                 }
//             }
//         });

//         return toWords.convert(calculations.total);
//     }, [calculations.total, currencyConfig]);

//     // Loading and error states
//     if (loading) {
//         return (
//             <div className="text-center p-5">
//                 <p>Loading invoice...</p>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className="text-center p-5 text-danger">
//                 <p>{error}</p>
//             </div>
//         );
//     }

//     if (!invoiceData || !currentClient) {
//         return (
//             <div className="text-center p-5">
//                 <p>Invoice not found</p>
//             </div>
//         );
//     }

//     return (
//         <div
//             id="invoice-content"
//             className='background-color-bill'
//             style={{
//                 width: "100%",
//                 margin: "0px",
//                 fontSize: "15px",
//                 backgroundColor: 'white'
//             }}
//         >
//             <h3 className='text-center mb-1'>Invoice Bill</h3>

//             <InvoiceHeader
//                 invoiceData={invoiceData}
//                 totalAmount={calculations.total}
//             />

//             <div className='row'>
//                 <div className='col-lg-4 col-md-4 col-sm-4'>
//                     <CompanyInfo />
//                 </div>
//                 <div className='col-lg-4 col-md-4 col-sm-4'></div>
//                 <div className='col-lg-4 col-md-4 col-sm-4'>
//                     <ClientInfo clientDetails={currentClient} />
//                 </div>
//             </div>

//             <div className='row m-1'>
//                 <InvoiceTable
//                     items={invoiceList}
//                     clientDetails={currentClient}
//                     currencySymbol={currencyConfig.symbol}
//                 />
//             </div>

//             <br />

//             <InvoiceSummary
//                 subtotal={calculations.subtotal}
//                 taxPercentage={calculations.taxPercentage}
//                 totalTax={calculations.totalTax}
//                 total={calculations.total}
//                 currencySymbol={currencyConfig.symbol}
//                 notes={invoiceData.notes}
//                 amountInWords={amountInWords}
//             />
//         </div>
//     );
// }

// export default InvoicePrint;

// import axios from 'axios';
// import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import apiUrl from '../../Environment/Api';
// import { ToWords } from 'to-words';

// // Constants
// const COUNTRY_CODE_INDIA = '91';
// const PRINT_DELAY = 1000;

// const CURRENCY_CONFIG = {
//     [COUNTRY_CODE_INDIA]: {
//         symbol: '₹',
//         name: 'Rupees',
//         fractionalUnit: 'Paisa'
//     },
//     default: {
//         symbol: '$',
//         name: 'Dollar',
//         fractionalUnit: 'Cents'
//     }
// };

// // Helper Functions
// const getCurrencyConfig = (countryCode) => {
//     return countryCode === COUNTRY_CODE_INDIA
//         ? CURRENCY_CONFIG[COUNTRY_CODE_INDIA]
//         : CURRENCY_CONFIG.default;
// };

// const formatDate = (dateString, format = 'short') => {
//     if (!dateString || dateString === "Invalid Date") {
//         return "";
//     }

//     const date = new Date(dateString);

//     if (format === 'short') {
//         return date.toLocaleDateString('en-US', {
//             month: 'short',
//             year: 'numeric'
//         });
//     }

//     return date.toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: '2-digit',
//         year: 'numeric',
//     }).replace(/\//g, '-');
// };

// // Sub-components
// const InvoiceHeader = ({ invoiceData, totalAmount }) => (
//     <div className='row mb-1'>
//         <div className='col-lg-6 col-md-6 col-sm-6'>
//             <img
//                 className='logo-bill'
//                 src={window.location.origin + require('../../../assets/img/Admin/vas-logo1-nav2.png')}
//                 alt="Company Logo"
//                 style={{ borderRadius: "50%", height: "100%" }}
//             />
//         </div>
//         <div className='col-lg-6 col-md-6 col-sm-6 mt-4'>
//             <div className='row'>
//                 <div className='col-lg-8 col-md-8 col-sm-8 line-height-space3'>
//                     <p className='invoice-list text-end'><b>Invoice No : {invoiceData?.invoiceId} </b></p>
//                     <p className='invoice-list text-end'><b>Invoice Date : {formatDate(invoiceData?.date, 'full')}</b></p>
//                     <p className='invoice-list text-end'><b>Due Date : {formatDate(invoiceData?.dueDate, 'full')}</b></p>
//                     <p className='invoice-list text-end'><b>Balance Due : ${totalAmount.toFixed(2)}</b></p>
//                 </div>
//                 {/* <div className='col-lg-4 col-md-4 col-sm-4 line-height-space3'>
//           <p className='text-black'></p>
//           <p className='text-black'></p>
//           <p className='text-black'></p>
//           <p className='text-black'></b></p>
//         </div> */}
//             </div>
//         </div>
//         <hr />
//     </div>
// );

// const CompanyInfo = () => (
//     <div className='logo-row line line-height-space3 mt-1'>
//         <b className='text-black'><p>VAS Post Production</p></b>
//         <p className='text-black'><b><i className="fa-solid fa-user"></i> - Vasanthan. K</b></p>
//         <p className='text-black'><b><i className="fa-solid fa-phone"></i></b> - +91 7708024254</p>
//         <p className='text-black'><i className="fa-solid fa-house"></i> - 87, Kamarajar Nagar,</p>
//         <p className='text-black indent'>Dadagapatti,</p>
//         <p className='text-black indent'>Salam-6.</p>
//     </div>
// );

// const ClientInfo = ({ clientDetails }) => (
//     <div>
//         <div className='row'>
//             <p className='text-black'><b>Bill to : </b></p>
//         </div>
//         <div className='logo-row line line-height-space3'>
//             <p className='text-black'>
//                 <b><i className="fa-solid fa-user"></i> - {clientDetails.name}</b>,
//             </p>
//             <p className='text-black'>
//                 <i className="fa-solid fa-phone"></i> - +{clientDetails.countryCode} {clientDetails.mobile},
//             </p>
//             <h6 className='text-black'>
//                 <i className="fa-solid fa-house"></i> - {clientDetails.address},
//             </h6>
//             <p className='text-black indent'>{clientDetails.country},</p>
//         </div>
//     </div>
// );

// const InvoiceTable = ({ items, clientDetails, currencySymbol }) => {
//     const isIndianClient = clientDetails.countryCode === COUNTRY_CODE_INDIA;
//     const [exchangeRate, setExchangeRate] = useState(1);

//     useEffect(() => {
//         if (isIndianClient) {
//             const fetchExchangeRate = async () => {
//                 try {
//                     const response = await fetch(
//                         "https://api.frankfurter.app/latest?from=USD&to=INR"
//                     );
//                     const data = await response.json();
//                     setExchangeRate(data.rates.INR);
//                 } catch (error) {
//                     console.error("Error fetching exchange rate:", error);
//                     setExchangeRate(85); // Fallback rate
//                 }
//             };
//             fetchExchangeRate();
//         }
//     }, [isIndianClient]);

//     // Calculate totals with currency conversion
//     const totals = useMemo(() => {
//         return items.reduce((acc, row) => {
//             const standard = parseFloat(row.standard || 0);
//             const premier = parseFloat(row.premier || 0);
//             const twilight = parseFloat(row.twilight || 0);
//             const day_to_dusk = parseFloat(row.day_to_dusk || 0);
//             const vra = parseFloat(row.vra || 0);
//             const vr = parseFloat(row.vr || 0);
//             const col7 = parseFloat(row.col7 || 0);
//             const col8 = parseFloat(row.col8 || 0);
//             const col9 = parseFloat(row.col9 || 0);
//             const col10 = parseFloat(row.col10 || 0);
//             const col11 = parseFloat(row.col11 || 0);
//             const col12 = parseFloat(row.col12 || 0);

//             // Price is stored in USD, convert if needed
//             const priceUSD = parseFloat(row.price || 0);
//             const price = isIndianClient ? priceUSD * exchangeRate : priceUSD;

//             const taxPercentage = parseFloat(row.tax || 0);
//             const taxAmount = (price * taxPercentage) / 100;
//             const rowAmount = price + taxAmount;

//             const rowTotal = standard + premier + twilight + day_to_dusk + vra + vr +
//                 col7 + col8 + col9 + col10 + col11 + col12 + price;

//             return {
//                 standard: acc.standard + standard,
//                 premier: acc.premier + premier,
//                 twilight: acc.twilight + twilight,
//                 day_to_dusk: acc.day_to_dusk + day_to_dusk,
//                 vra: acc.vra + vra,
//                 vr: acc.vr + vr,
//                 col7: acc.col7 + col7,
//                 col8: acc.col8 + col8,
//                 col9: acc.col9 + col9,
//                 col10: acc.col10 + col10,
//                 col11: acc.col11 + col11,
//                 col12: acc.col12 + col12,
//                 price: acc.price + price,
//                 amount: acc.amount + rowAmount,
//                 subtotal: acc.subtotal + rowTotal
//             };
//         }, {
//             standard: 0, premier: 0, twilight: 0, day_to_dusk: 0, vra: 0, vr: 0,
//             col7: 0, col8: 0, col9: 0, col10: 0, col11: 0, col12: 0,
//             price: 0, amount: 0, subtotal: 0
//         });
//     }, [items, isIndianClient, exchangeRate]);

//     const dynamicColumns = ['col7', 'col8', 'col9', 'col10', 'col11', 'col12'];
//     const columnsWithData = dynamicColumns.filter(col =>
//         items.some(item => item[col] && item[col].toString().trim() !== '' && parseFloat(item[col] || 0) !== 0)
//     );

//     return (
//         <table className='table table-striped'>
//             {/* ... thead stays the same ... */}
//             <tbody>
//                 {items.map((row, index) => {
//                     // Convert price from USD to client currency
//                     const priceUSD = parseFloat(row.price || 0);
//                     const price = isIndianClient ? priceUSD * exchangeRate : priceUSD;
//                     const taxPercentage = parseFloat(row.tax || 0);
//                     const taxAmount = (price * taxPercentage) / 100;
//                     const rowAmount = price + taxAmount;

//                     return (
//                         <tr key={index} className={index % 2 === 1 ? 'table-secondary' : ''}>
//                             <td className='text-center sno' scope="row">{index + 1}</td>
//                             <td className='datetable'>{formatDate(row.date, 'full')}</td>
//                             <td>{row.projectName}</td>
//                             <td className='text-center'>{row.standard || '-'}</td>
//                             <td className='text-center'>{row.premier || '-'}</td>
//                             <td className='text-center'>{row.twilight || '-'}</td>
//                             <td className='text-center'>{row.day_to_dusk || '-'}</td>
//                             <td className='text-center'>{row.vra || '-'}</td>
//                             <td className='text-center'>{row.vr || '-'}</td>

//                             {columnsWithData.map(col => (
//                                 <td key={col} className='text-center'>{row[col] || '-'}</td>
//                             ))}

//                             <td className='pricetableprint'>
//                                 {currencySymbol} {price.toFixed(2)}
//                             </td>
//                             <td className='amounttableprint'>
//                                 {currencySymbol} {rowAmount.toFixed(2)}
//                             </td>
//                         </tr>
//                     );
//                 })}
//                 <tr className='table-light'>
//                     <td></td>
//                     <td></td>
//                     <td><b>Total</b></td>
//                     <td className='text-center'><b>{totals.standard.toFixed(2)}</b></td>
//                     <td className='text-center'><b>{totals.premier.toFixed(2)}</b></td>
//                     <td className='text-center'><b>{totals.twilight.toFixed(2)}</b></td>
//                     <td className='text-center'><b>{totals.day_to_dusk.toFixed(2)}</b></td>
//                     <td className='text-center'><b>{totals.vra.toFixed(2)}</b></td>
//                     <td className='text-center'><b>{totals.vr.toFixed(2)}</b></td>
//                     {columnsWithData.map(col => (
//                         <td key={`total-${col}`} className='text-center'><b>{totals[col].toFixed(2)}</b></td>
//                     ))}
//                     <td className='text-center'><b>{currencySymbol} {totals.price.toFixed(2)}</b></td>
//                     <td><b>{currencySymbol} {totals.amount.toFixed(2)}</b></td>
//                 </tr>
//             </tbody>
//         </table>
//     );
// };

// const InvoiceSummary = ({
//     subtotal,
//     taxPercentage,
//     totalTax,
//     total,
//     currencySymbol,
//     notes,
//     amountInWords
// }) => (
//     <div className='row'>
//         <div className='col-lg-4 col-md-4 col-sm-4'>
//             <p className='form-label notes-style'><b>Amount in Words : </b></p>
//             <p className='notes-style text-black'>{amountInWords}</p>
//             <p className='form-label notes-style'><b>Notes</b></p>
//             <p className='notes-style'>{notes}</p>
//         </div>
//         <div className='col-lg-8 col-md-8 col-sm-8'>
//             <div className='row total-content'>
//                 <div className='col-lg-7 col-md-7 col-sm-7 line-height-space3'>
//                     <p className='invoice-list text-end'><b>Sub Total</b></p>
//                     <p className='invoice-list text-end'><b>Paypal Tax ({taxPercentage}%)</b></p>
//                     <p className='invoice-list text-end'><b>Net Total</b></p>
//                 </div>
//                 <div className='col-lg-5 col-md-5 col-sm-5 line-height-space3'>
//                     <p className='text-black'>: {currencySymbol} {subtotal.toFixed(2)}</p>
//                     <p className='text-black'>: {currencySymbol} {totalTax.toFixed(2)}</p>
//                     <b className='text-black'>: {currencySymbol} {total.toFixed(2)}</b>
//                 </div>
//             </div>
//         </div>
//     </div>
// );

// // Main Component
// function InvoicePrint() {
//     const navigate = useNavigate();
//     const printRef = useRef(false);
//     const { invoice_id } = useParams();

//     // State
//     const [invoiceData, setInvoiceData] = useState(null);
//     const [invoiceList, setInvoiceList] = useState([]);
//     const [clientDetails, setClientDetails] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     // Fetch invoice data
//     const fetchInvoiceData = useCallback(async () => {
//         try {
//             setLoading(true);
//             setError(null);

//             const [detailsResponse, listResponse, clientsResponse] = await Promise.all([
//                 axios.get(`${apiUrl}/invoicedetails/${invoice_id}`),
//                 axios.get(`${apiUrl}/invoicelist/${invoice_id}`),
//                 axios.get(`${apiUrl}/clientdetails`)
//             ]);

//             setInvoiceData(detailsResponse.data[0]);
//             setInvoiceList(listResponse.data);
//             console.log("===== INVOICE LIST DATA FROM BACKEND =====");
//             console.log(JSON.stringify(listResponse.data, null, 2)); // ADD THIS
//             console.log("==========================================");
//             setClientDetails(clientsResponse.data);
//         } catch (err) {
//             console.error('Error fetching invoice data:', err);
//             setError('Failed to load invoice data');
//         } finally {
//             setLoading(false);
//         }
//     }, [invoice_id]);

//     useEffect(() => {
//         fetchInvoiceData();
//     }, [fetchInvoiceData]);

//     // Handle printing
//     useEffect(() => {
//         if (loading || !invoiceData) return;

//         const printTimer = setTimeout(() => {
//             if (!printRef.current) {
//                 window.onbeforeprint = () => {
//                     document.title = `${invoice_id}`;
//                 };
//                 window.print();
//                 printRef.current = true;
//             } else {
//                 navigate('/invoice');
//             }
//         }, PRINT_DELAY);

//         return () => clearTimeout(printTimer);
//     }, [invoice_id, navigate, loading, invoiceData]);

//     // Derived data
//     const currentClient = useMemo(() => {
//         if (!invoiceData?.clientId || !clientDetails.length) return null;

//         const client = clientDetails.find(c => c.id === invoiceData.clientId);
//         return client ? {
//             name: client.clientName,
//             address: client.address,
//             country: client.country,
//             mobile: client.mobile,
//             countryCode: client.countrycode
//         } : null;
//     }, [clientDetails, invoiceData]);

//     const currencyConfig = useMemo(() => {
//         return getCurrencyConfig(currentClient?.countryCode);
//     }, [currentClient]);

//     const calculations = useMemo(() => {
//         // Subtotal = sum of all prices only (no tax included)
//         const subtotal = invoiceList.reduce((acc, row) => {
//             const price = parseFloat(row.price || 0);
//             return acc + price;
//         }, 0);

//         const totalTax = parseFloat(invoiceData?.totalTax || 0);
//         const total = subtotal + totalTax;
//         const taxPercentage = invoiceList[0]?.tax || 0;

//         return { subtotal, totalTax, total, taxPercentage };
//     }, [invoiceList, invoiceData]);

//     const amountInWords = useMemo(() => {
//         const toWords = new ToWords({
//             localeCode: 'en-IN',
//             converterOptions: {
//                 currency: true,
//                 ignoreDecimal: false,
//                 ignoreZeroCurrency: false,
//                 doNotAddOnly: false,
//                 currencyOptions: {
//                     name: currencyConfig.name,
//                     plural: currencyConfig.name,
//                     symbol: currencyConfig.symbol,
//                     fractionalUnit: {
//                         name: currencyConfig.fractionalUnit,
//                         plural: currencyConfig.fractionalUnit,
//                         symbol: '',
//                     },
//                 }
//             }
//         });

//         return toWords.convert(calculations.total);
//     }, [calculations.total, currencyConfig]);

//     // Loading and error states
//     if (loading) {
//         return (
//             <div className="text-center p-5">
//                 <p>Loading invoice...</p>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className="text-center p-5 text-danger">
//                 <p>{error}</p>
//             </div>
//         );
//     }

//     if (!invoiceData || !currentClient) {
//         return (
//             <div className="text-center p-5">
//                 <p>Invoice not found</p>
//             </div>
//         );
//     }

//     return (
//         <div
//             id="invoice-content"
//             className='background-color-bill'
//             style={{
//                 width: "100%",
//                 margin: "0px",
//                 fontSize: "15px",
//                 backgroundColor: 'white'
//             }}
//         >
//             <h3 className='text-center mb-1'>Invoice Bill</h3>

//             <InvoiceHeader
//                 invoiceData={invoiceData}
//                 totalAmount={calculations.total}
//             />

//             <div className='row'>
//                 <div className='col-lg-4 col-md-4 col-sm-4'>
//                     <CompanyInfo />
//                 </div>
//                 <div className='col-lg-4 col-md-4 col-sm-4'></div>
//                 <div className='col-lg-4 col-md-4 col-sm-4'>
//                     <ClientInfo clientDetails={currentClient} />
//                 </div>
//             </div>

//             <div className='row m-1'>
//                 <InvoiceTable
//                     items={invoiceList}
//                     clientDetails={currentClient}
//                     currencySymbol={currencyConfig.symbol}
//                 />
//             </div>

//             <br />

//             <InvoiceSummary
//                 subtotal={calculations.subtotal}
//                 taxPercentage={calculations.taxPercentage}
//                 totalTax={calculations.totalTax}
//                 total={calculations.total}
//                 currencySymbol={currencyConfig.symbol}
//                 notes={invoiceData.notes}
//                 amountInWords={amountInWords}
//             />
//         </div>
//     );
// }

// export default InvoicePrint;

import axios from 'axios';
import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import apiUrl from '../../Environment/Api';
import { ToWords } from 'to-words';

// Constants
const COUNTRY_CODE_INDIA = '91';
const PRINT_DELAY = 1000;

const CURRENCY_CONFIG = {
    [COUNTRY_CODE_INDIA]: {
        symbol: '₹',
        name: 'Rupees',
        fractionalUnit: 'Paisa'
    },
    default: {
        symbol: '$',
        name: 'Dollar',
        fractionalUnit: 'Cents'
    }
};

// Helper Functions
const getCurrencyConfig = (countryCode) => {
    return countryCode === COUNTRY_CODE_INDIA
        ? CURRENCY_CONFIG[COUNTRY_CODE_INDIA]
        : CURRENCY_CONFIG.default;
};

const formatDate = (dateString, format = 'short') => {
    if (!dateString || dateString === "Invalid Date") {
        return "";
    }

    const date = new Date(dateString);

    if (format === 'short') {
        return date.toLocaleDateString('en-US', {
            month: 'short',
            year: 'numeric'
        });
    }

    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).replace(/\//g, '-');
};

// Sub-components
const InvoiceHeader = ({ invoiceData, totalAmount, currencySymbol }) => (
    <div className='row mb-1'>
        <div className='col-lg-6 col-md-6 col-sm-6'>
            <img
                className='logo-bill'
                src={window.location.origin + require('../../../assets/img/Admin/vas-logo1-nav2.png')}
                alt="Company Logo"
                style={{ borderRadius: "50%", height: "100%" }}
            />
        </div>
        <div className='col-lg-6 col-md-6 col-sm-6 mt-4'>
            <div className='row'>
                <div className='col-lg-8 col-md-8 col-sm-8 line-height-space3'>
                    <p className='invoice-list text-end'><b>Invoice No : {invoiceData?.invoiceId} </b></p>
                    <p className='invoice-list text-end'><b>Invoice Date : {formatDate(invoiceData?.date, 'full')}</b></p>
                    <p className='invoice-list text-end'><b>Due Date : {formatDate(invoiceData?.dueDate, 'full')}</b></p>
                    <p className='invoice-list text-end'><b>Balance Due : {currencySymbol}{totalAmount.toFixed(2)}</b></p>
                </div>
            </div>
        </div>
        <hr />
    </div>
);

const CompanyInfo = () => (
    <div className='logo-row line line-height-space3 mt-1'>
        <b className='text-black'><p>Click On</p></b>
        <p className='text-black'><b><i className="fa-solid fa-user"></i> - Vasanthan. K</b></p>
        <p className='text-black'><b><i className="fa-solid fa-phone"></i></b> - +91 7708024254</p>
        <p className='text-black'><i className="fa-solid fa-house"></i> - 87, Kamarajar Nagar,</p>
        <p className='text-black indent'>Dadagapatti,</p>
        <p className='text-black indent'>Salam-6.</p>
    </div>
);

const ClientInfo = ({ clientDetails }) => (
    <div>
        <div className='row'>
            <p className='text-black'><b>Bill to : </b></p>
        </div>
        <div className='logo-row line line-height-space3'>
            <p className='text-black'>
                <b><i className="fa-solid fa-user"></i> - {clientDetails.name}</b>,
            </p>
            {/* <p className='text-black'>
                <i className="fa-solid fa-phone"></i> - +{clientDetails.countryCode} {clientDetails.mobile},
            </p> */}
            <h6 className='text-black'>
                <i className="fa-solid fa-house"></i> - {clientDetails.address},
            </h6>
            <p className='text-black indent'>{clientDetails.country},</p>
        </div>
    </div>
);

const InvoiceTable = ({ items, clientDetails, currencySymbol, exchangeRate, columnNames, visibleColumns }) => {
    const isIndianClient = clientDetails.countryCode === COUNTRY_CODE_INDIA;

    // Calculate totals with currency conversion
    const totals = useMemo(() => {
        return items.reduce((acc, row) => {
            // Calculate totals for all visible columns
            const columnTotals = {};
            visibleColumns.forEach(col => {
                columnTotals[col] = acc[col] ? acc[col] + parseFloat(row[col] || 0) : parseFloat(row[col] || 0);
            });

            // Price is stored in USD, convert if needed
            const priceUSD = parseFloat(row.price || 0);
            const price = isIndianClient ? priceUSD * exchangeRate : priceUSD;

            const taxPercentage = parseFloat(row.tax || 0);
            const taxAmount = (price * taxPercentage) / 100;
            const rowAmount = price + taxAmount;

            return {
                ...acc,
                ...columnTotals,
                price: acc.price + price,
                amount: acc.amount + rowAmount,
                tax: acc.tax + taxAmount
            };
        }, { price: 0, amount: 0, tax: 0 });
    }, [items, isIndianClient, exchangeRate, visibleColumns]);

    return (
        <table className='table table-striped'>
            <thead className='table-dark'>
                <tr>
                    <th className='sno' scope="col">S No.</th>
                    <th className='datetable' scope="col">Date</th>
                    <th scope="col">Address</th>

                    {/* Dynamic column headers with custom names */}
                    {visibleColumns.map(col => (
                        <th key={col} scope="col">{columnNames[col] || col.toUpperCase()}</th>
                    ))}

                    <th className='pricetableprint' scope="col">Price</th>
                    <th className='amounttableprint' scope="col">Amount</th>
                </tr>
            </thead>
            <tbody>
                {items.map((row, index) => {
                    // Convert price from USD to client currency
                    const priceUSD = parseFloat(row.price || 0);
                    const price = isIndianClient ? priceUSD * exchangeRate : priceUSD;
                    const taxPercentage = parseFloat(row.tax || 0);
                    const taxAmount = (price * taxPercentage) / 100;
                    const rowAmount = price + taxAmount;

                    return (
                        <tr key={index} className={index % 2 === 1 ? 'table-secondary' : ''}>
                            <td className='text-center sno' scope="row">{index + 1}</td>
                            <td className='datetable'>{formatDate(row.date, 'full')}</td>
                            <td>{row.projectName}</td>

                            {/* Dynamic column data */}
                            {visibleColumns.map(col => (
                                <td key={col} className=''>{row[col] || '-'}</td>
                            ))}

                            <td className='pricetableprint'>
                                {currencySymbol} {price.toFixed(2)}
                            </td>
                            <td className='amounttableprint'>
                                {currencySymbol} {rowAmount.toFixed(2)}
                            </td>
                        </tr>
                    );
                })}
                <tr className='table-light'>
                    <td></td>
                    <td></td>
                    <td><b>Total</b></td>
                    
                    {/* Dynamic column totals */}
                    {visibleColumns.map(col => (
                        <td key={`total-${col}`} className=''>
                            <b>{(totals[col] || 0).toFixed(2)}</b>
                        </td>
                    ))}
                    
                    <td><b>{currencySymbol} {totals.price.toFixed(2)}</b></td>
                    <td><b>{currencySymbol} {totals.amount.toFixed(2)}</b></td>
                </tr>
            </tbody>
        </table>
    );
};

const InvoiceSummary = ({
    subtotal,
    taxPercentage,
    totalTax,
    total,
    currencySymbol,
    notes,
    amountInWords
}) => (
    <div className='row'>
        <div className='col-lg-4 col-md-4 col-sm-4'>
            <p className='form-label notes-style'><b>Amount in Words : </b></p>
            <p className='notes-style text-black'>{amountInWords}</p>
            <p className='form-label notes-style'><b>Notes</b></p>
            <p className='notes-style'>{notes}</p>
        </div>
        <div className='col-lg-8 col-md-8 col-sm-8'>
            <div className='row total-content'>
                <div className='col-lg-7 col-md-7 col-sm-7 line-height-space3'>
                    <p className='invoice-list text-end'><b>Sub Total</b></p>
                    <p className='invoice-list text-end'><b>Paypal Tax ({taxPercentage}%)</b></p>
                    <p className='invoice-list text-end'><b>Net Total</b></p>
                </div>
                <div className='col-lg-5 col-md-5 col-sm-5 line-height-space3'>
                    <p className='text-black'>: {currencySymbol} {subtotal.toFixed(2)}</p>
                    <p className='text-black'>: {currencySymbol} {totalTax.toFixed(2)}</p>
                    <b className='text-black'>: {currencySymbol} {total.toFixed(2)}</b>
                </div>
            </div>
        </div>
    </div>
);

// Main Component
function InvoicePrint() {
    const navigate = useNavigate();
    const printRef = useRef(false);
    const { invoice_id } = useParams();

    // State
    const [invoiceData, setInvoiceData] = useState(null);
    const [invoiceList, setInvoiceList] = useState([]);
    const [clientDetails, setClientDetails] = useState([]);
    const [exchangeRate, setExchangeRate] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // NEW: State for column configuration
    const [columnNames, setColumnNames] = useState({
        standard: "Standard",
        premier: "Premier",
        twilight: "Twilight",
        day_to_dusk: "Day to Dusk",
        vra: "VRA(5$)",
        vr: "VR(12$)",
        col7: "Column 7",
        col8: "Column 8",
        col9: "Column 9",
        col10: "Column 10",
        col11: "Column 11",
        col12: "Column 12"
    });
    const [visibleColumns, setVisibleColumns] = useState([]);

    // Fetch exchange rate
    useEffect(() => {
        const fetchExchangeRate = async () => {
            try {
                const response = await fetch(
                    "https://api.frankfurter.app/latest?from=USD&to=INR"
                );
                const data = await response.json();
                setExchangeRate(data.rates.INR);
            } catch (error) {
                console.error("Error fetching exchange rate:", error);
                setExchangeRate(85); // Fallback rate
            }
        };
        fetchExchangeRate();
    }, []);

    // Fetch invoice data
    const fetchInvoiceData = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            const [detailsResponse, listResponse, clientsResponse] = await Promise.all([
                axios.get(`${apiUrl}/invoicedetails/${invoice_id}`),
                axios.get(`${apiUrl}/invoicelist/${invoice_id}`),
                axios.get(`${apiUrl}/clientdetails`)
            ]);

            setInvoiceData(detailsResponse.data[0]);
            setInvoiceList(listResponse.data);
            setClientDetails(clientsResponse.data);

            // NEW: Fetch column configuration
            try {
                const columnResponse = await axios.get(`${apiUrl}/invoice-columns/${invoice_id}`);
                
                if (columnResponse.data.status === 'success' && columnResponse.data.data) {
                    const savedColumns = columnResponse.data.data;
                    
                    // Update column names with saved values
                    setColumnNames({
                        standard: savedColumns.standard || "Standard",
                        premier: savedColumns.premier || "Premier",
                        twilight: savedColumns.twilight || "Twilight",
                        day_to_dusk: savedColumns.day_to_dusk || "Day to Dusk",
                        vra: savedColumns.vra || "VRA(5$)",
                        vr: savedColumns.vr || "VR(12$)",
                        col7: savedColumns.col7 || "Column 7",
                        col8: savedColumns.col8 || "Column 8",
                        col9: savedColumns.col9 || "Column 9",
                        col10: savedColumns.col10 || "Column 10",
                        col11: savedColumns.col11 || "Column 11",
                        col12: savedColumns.col12 || "Column 12"
                    });
                }
            } catch (err) {
                console.error("Error loading column configuration:", err);
            }

            // Determine visible columns based on data
            const allColumns = ['standard', 'premier', 'twilight', 'day_to_dusk', 'vra', 'vr', 'col7', 'col8', 'col9', 'col10', 'col11', 'col12'];
            const visibleCols = [];

            allColumns.forEach((col) => {
                const hasData = listResponse.data.some(item =>
                    item[col] && item[col].toString().trim() !== '' && parseFloat(item[col] || 0) !== 0
                );
                if (hasData) {
                    visibleCols.push(col);
                }
            });

            setVisibleColumns(visibleCols);

        } catch (err) {
            console.error('Error fetching invoice data:', err);
            setError('Failed to load invoice data');
        } finally {
            setLoading(false);
        }
    }, [invoice_id]);

    useEffect(() => {
        fetchInvoiceData();
    }, [fetchInvoiceData]);

    // Handle printing
    useEffect(() => {
        if (loading || !invoiceData) return;

        const printTimer = setTimeout(() => {
            if (!printRef.current) {
                window.onbeforeprint = () => {
                    document.title = `${invoice_id}`;
                };
                window.print();
                printRef.current = true;
            } else {
                navigate('/invoice');
            }
        }, PRINT_DELAY);

        return () => clearTimeout(printTimer);
    }, [invoice_id, navigate, loading, invoiceData]);

    // Derived data
    const currentClient = useMemo(() => {
        if (!invoiceData?.clientId || !clientDetails.length) return null;

        const client = clientDetails.find(c => c.id === invoiceData.clientId);
        return client ? {
            name: client.clientName,
            address: client.address,
            country: client.country,
            mobile: client.mobile,
            countryCode: client.countrycode
        } : null;
    }, [clientDetails, invoiceData]);

    const currencyConfig = useMemo(() => {
        return getCurrencyConfig(currentClient?.countryCode);
    }, [currentClient]);

    const isIndianClient = currentClient?.countryCode === COUNTRY_CODE_INDIA;

    const calculations = useMemo(() => {
        // Calculate subtotal with currency conversion
        const subtotal = invoiceList.reduce((acc, row) => {
            const priceUSD = parseFloat(row.price || 0);
            const price = isIndianClient ? priceUSD * exchangeRate : priceUSD;
            return acc + price;
        }, 0);

        // Calculate total tax with currency conversion
        const totalTax = invoiceList.reduce((acc, row) => {
            const priceUSD = parseFloat(row.price || 0);
            const price = isIndianClient ? priceUSD * exchangeRate : priceUSD;
            const taxPercentage = parseFloat(row.tax || 0);
            const taxAmount = (price * taxPercentage) / 100;
            return acc + taxAmount;
        }, 0);

        const total = subtotal + totalTax;
        const taxPercentage = invoiceList[0]?.tax || 0;

        return { subtotal, totalTax, total, taxPercentage };
    }, [invoiceList, isIndianClient, exchangeRate]);

    const amountInWords = useMemo(() => {
        const toWords = new ToWords({
            localeCode: 'en-IN',
            converterOptions: {
                currency: true,
                ignoreDecimal: false,
                ignoreZeroCurrency: false,
                doNotAddOnly: false,
                currencyOptions: {
                    name: currencyConfig.name,
                    plural: currencyConfig.name,
                    symbol: currencyConfig.symbol,
                    fractionalUnit: {
                        name: currencyConfig.fractionalUnit,
                        plural: currencyConfig.fractionalUnit,
                        symbol: '',
                    },
                }
            }
        });

        return toWords.convert(calculations.total);
    }, [calculations.total, currencyConfig]);

    // Loading and error states
    if (loading) {
        return (
            <div className="text-center p-5">
                <p>Loading invoice...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center p-5 text-danger">
                <p>{error}</p>
            </div>
        );
    }

    if (!invoiceData || !currentClient) {
        return (
            <div className="text-center p-5">
                <p>Invoice not found</p>
            </div>
        );
    }

    return (
        <div
            id="invoice-content"
            className='background-color-bill'
            style={{
                width: "100%",
                margin: "0px",
                fontSize: "15px",
                backgroundColor: 'white'
            }}
        >
            <h3 className='text-center mb-1'>Invoice Bill</h3>

            <InvoiceHeader
                invoiceData={invoiceData}
                totalAmount={calculations.total}
                currencySymbol={currencyConfig.symbol}
            />

            <div className='row'>
                <div className='col-lg-4 col-md-4 col-sm-4'>
                    <CompanyInfo />
                </div>
                <div className='col-lg-4 col-md-4 col-sm-4'></div>
                <div className='col-lg-4 col-md-4 col-sm-4'>
                    <ClientInfo clientDetails={currentClient} />
                </div>
            </div>

            <div className='row m-1'>
                <InvoiceTable
                    items={invoiceList}
                    clientDetails={currentClient}
                    currencySymbol={currencyConfig.symbol}
                    exchangeRate={exchangeRate}
                    columnNames={columnNames}
                    visibleColumns={visibleColumns}
                />
            </div>

            <br />

            <InvoiceSummary
                subtotal={calculations.subtotal}
                taxPercentage={calculations.taxPercentage}
                totalTax={calculations.totalTax}
                total={calculations.total}
                currencySymbol={currencyConfig.symbol}
                notes={invoiceData.notes}
                amountInWords={amountInWords}
            />
        </div>
    );
}

export default InvoicePrint;